<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="users"
          item-key="uid"
          show-select
          :search="search"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar usuario"
              class="ma-2"
              single-line
              hide-details
            ></v-text-field>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon class="mr-2" color="blue" @click="editItem(item)">
              mode_edit
            </v-icon>
            <v-icon color="error" @click="deleteItem(item)">
              delete
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog v-model="openDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Eliminar usuario
        </v-card-title>

        <v-card-text class="mt-2">
          Estas seguro de eliminar el usuario {{ currentUserAction.email }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="openDialog = false">
            Cancelar
          </v-btn>
          <v-btn color="error" @click="confirmDelete">
            Eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { firestore } from "@/config/firebase";
import { errorMessage } from "@/services/MessageService";
import { loaderDone, loaderStart } from "@/services/LoaderService";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      singleSelect: false,
      selected: [],
      search: "",
      openDialog: false,
      headers: [
        {
          text: "Nombre",
          align: "start",
          value: "name"
        },
        { text: "Correo", value: "email" },
        { text: "Acciones", value: "actions", sortable: false }
      ],
      users: [],
      currentUserAction: {}
    };
  },
  created() {
    this.getUsers();
  },
  methods: {
    ...mapActions("user/register", ["deleteUser"]),
    async getUsers() {
      loaderStart();
      try {
        const userSnap = await firestore("users").get();
        userSnap.forEach(doc => {
          const data = {
            email: doc.data().email,
            name: doc.data().name,
            uid: doc.data().uid
          };
          this.users.push(data);
        });
        loaderDone();
      } catch (error) {
        errorMessage("No se pudieron obtener los usuarios");
        loaderDone();
      }
    },
    editItem(item) {
      if (item.uid) {
        this.$router.push({
          name: "usersAndPermissionsActions",
          params: { action: "edit", id: item.uid }
        });
      } else {
        errorMessage("El usuario no tiene el UID");
      }
    },
    deleteItem(item) {
      this.currentUserAction = item;
      this.openDialog = true;
    },
    async confirmDelete() {
      this.openDialog = false;
      await this.deleteUser(this.currentUserAction.uid);
      this.users = [];
      this.getUsers();
      loaderDone();
    }
  }
};
</script>

<style></style>
